import React, { useState, useEffect, forwardRef } from "react";
import styles from "./SearchSelect.module.css";

const SearchSelect = forwardRef(
    (
        {
            label,
            options = [],
            placeholder = "Search...",
            error,
            helpText,
            required = false,
            disabled = false,
            className = "",
            value,               // controlled value (script_id)
            onChange,
            ...rest
        },
        ref
    ) => {

        const [search, setSearch] = useState("");
        const [showList, setShowList] = useState(false);
        const [filtered, setFiltered] = useState([]);

        useEffect(() => {
            if (value && options.length > 0) {
                const match = options.find(o => o.value === value);
                if (match && search !== match.label) {
                    setSearch(match.label);
                } else if (!match && value !== "") {
                    // Optional: clear if no match (e.g., invalid ID)
                    setSearch("");
                }
            }
        }, [value, options]); 



        // 🔍 filter matches
        useEffect(() => {
            if (!search.trim()) {
                setFiltered([]);
                return;
            }

            setFiltered(
                options.filter(o =>
                    o.label.toLowerCase().includes(search.toLowerCase())
                )
            );
        }, [search, options]);

        return (
            <div className={`${styles.wrapper} ${className}`}>

                {label && (
                    <label className={`${styles.label} ${required ? styles.required : ""}`}>
                        {label}
                        {required && <span className={styles.asterisk}>*</span>}
                    </label>
                )}

                <div className={styles.inputWrapper}>
                    <input
                        ref={ref}
                        type="text"
                        value={search}
                        placeholder={placeholder}
                        disabled={disabled}
                        className={`${styles.input} ${error ? styles.errorInput : ""}`}
                        onFocus={() => setShowList(true)}
                        onChange={(e) => {
                            const text = e.target.value;
                            setSearch(text);
                            setShowList(true);

                            // Pass raw text to form only while typing
                            if (onChange) {
                                onChange({
                                    target: {
                                        name: rest.name,
                                        value: ""
                                    }
                                });
                            }
                        }}
                        {...rest}
                    />

                    {showList && filtered.length > 0 && (
                        <div className={styles.dropdown}>
                            {filtered.map((item) => (
                                <div
                                    key={item.value}
                                    className={styles.dropdownItem}
                                    onClick={() => {
                                        // set label in input
                                        setSearch(item.label);
                                        setShowList(false);

                                        // send selected value to form
                                        if (onChange) {
                                            onChange({
                                                target: {
                                                    name: rest.name,
                                                    value: item.value
                                                }
                                            });
                                        }
                                    }}
                                >
                                    {item.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {helpText && !error && <p className={styles.helpText}>{helpText}</p>}
                {error && <p className={styles.errorText}>{error}</p>}
            </div>
        );
    }
);

SearchSelect.displayName = "SearchSelect";
export default SearchSelect;